import React, { useState, RefObject } from "react";
import "./css/index.css";
import EdiHeader from "./components/EdiHeader";
import Screen from "./components/Screen";
import Popup from "./components/Popup";
import { useDispatch } from "react-redux";
import { PurposeType } from "../../interface/interface";

type Props = {
  ScreenRef: RefObject<HTMLDivElement>;
  dataKey: string;
  purpose: PurposeType | "rewards";
  SaveContent: () => void;
};

/** 에디터 */
function Editor({ ScreenRef, dataKey, purpose, SaveContent }: Props) {
  const dispatch = useDispatch();

  const [isUp, setIsUp] = useState({
    status: false,
    type: "",
  });
  return (
    <div className="editor">
      <div className="editor-wrapper">
        <EdiHeader
          setIsUp={setIsUp}
          dispatch={dispatch}
          dataKey={dataKey}
          purpose={purpose}
          SaveContent={SaveContent}
        />
        <Screen ScreenRef={ScreenRef} SaveContent={SaveContent} />
      </div>
      <Popup isUp={isUp} setIsUp={setIsUp} dataKey={dataKey} />
    </div>
  );
}

export default Editor;
